module.exports = __webpack_public_path__ + "static/media/anguished-face-svgrepo-com.ce7cf5d0.svg";